@if(signInResponse?.data?.applicantId == null ||
signInResponse?.data?.applicantId == undefined){
@if(showTempSuspendMessage){
<div class="w-100 rounded-5 py-3 mb-4 d-flex flex-column align-items-center px-2 warning" role="alert">
  <img class="mx-2 upload-icon flex-shrink-0" style="width: 35px;" src="assets/icons/warning-02-rounded.svg" alt="">
  {{translateService.currentLang === 'ar' ? '' : ''}}
  @if(translateService.currentLang === 'ar'){
  <p class="mb-0 text-3 line-3 p-2 mt-1 text-center">تم تعليق حسابك مؤقتًا
    لإعادة تفعيل حسابك، <span style="color: var(--form-element-input-color);" (click)="navigate('/contact-us')"
      class="c-pointer  text-nowrap ibm-semibold">إضغط هنا</span> لإرسال طلبك إلى فريق الدعم</p>
  }
  @else{
  <p class="mb-0 text-3 line-3 p-2 mt-1 text-center">Your Account has been temporarily suspended,
    To reactivate your Account, please <span style="color: var(--form-element-input-color);"
      (click)="navigate('/contact-us')" class="c-pointer ibm-semibold">Click here</span> to send a request
    to Support Team</p>
  }
</div>
}
<form [formGroup]="signInForm" (ngSubmit)="onClickSignIn()" autocomplete="off">
  <div>
    <div class="form-floating">
      <input class="form-control px-4" type="email" autocomplete="off"
        [placeholder]="'EMAIL_VERIFICATION.EMAIL'| translate" formControlName="email" appNoArabicInput />
      <label>{{ "EMAIL_VERIFICATION.EMAIL" | translate }}</label>
      <app-validation-message [control]="signInForm.get('email')"></app-validation-message>
    </div>
  </div>
  <div>
    <div class="form-floating mt-4 position-relative">
      <input class="form-control px-4 password" type="text" autocomplete="off" [ngClass]="
        showPassword
          ? 'form-control password-input '
          : 'form-control password-input pw'
      " [placeholder]=" 'SIGN_IN.PASSWORD' | translate" formControlName="password" appNoWhitespace />
      <label>{{ "SIGN_IN.PASSWORD" | translate }}</label>
      @if (!showPassword) {
      <span class="password-eye-icon" (click)="showPassword = !showPassword">
        <img class="" src="assets/icons/view-stroke-rounded.svg" />
      </span>
      } @else {
      <span class="password-eye-icon" (click)="showPassword = !showPassword">

        <img class="" src="assets/icons/view-off-slash-stroke-rounded.svg" />
      </span>
      }
      <app-validation-message [control]="signInForm.get('password')"
        [formSubmission]="isSubmitted"></app-validation-message>
    </div>
  </div>
  <p class="mt-4 text-2 ibm-medium click-here">
    {{ "SIGN_IN.FORGOT_YOUR_PASSWORD" | translate
    }}<span class="c-pointer ibm-medium" (click)="navigate('/forgot-password')">{{
      "SIGN_IN.CLICK_HERE" | translate
      }}</span>
  </p>
  <button [disabled]="!signInForm.valid" type="submit" class="btn-1 w-100 p-2 my-4">
    {{ "SIGN_IN.LOGIN_BUTTON" | translate }}
  </button>
</form>
}

@if(signInResponse?.data?.applicantId != null &&
signInResponse?.data?.applicantId != undefined){
<app-email-verification [parentComponent]="componentName" [email]="signInForm.value.email"
  [additionalData]="signInResponse?.data" (verifiedOTP)="onVerifyOTP($event)"></app-email-verification>
}
<!-- captcha-->
@if(showCaptcha){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}
<p class="click-here text-2 ibm-medium text-center">
  {{ "SIGN_IN.DONT_HAVE_ACCOUNT" | translate }}
  <span class="c-pointer ibm-medium" (click)="navigate('/sign-up')">{{
    "SIGN_IN.CLICK_HERE_TO_SIGN_UP" | translate
    }}</span>
</p>